var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small mr10",
            on: {
              click: function($event) {
                _vm.showShopDlg()
              }
            }
          },
          [_vm._v("选择机构")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "custom-tbl" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "body" },
        _vm._l(_vm.comnAllocForm.allocForms, function(allocForm) {
          return _vm.comnAllocForm.allocForms.length > 0
            ? _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  { staticStyle: { "text-align": "left", width: "300px" } },
                  [_vm._v(_vm._s(allocForm.buyerShopName))]
                ),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "inline-block mr10",
                      staticStyle: { width: "500px" }
                    },
                    [_vm._v(_vm._s(allocForm.buyerRecvRegionName))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left" } },
                  [
                    _c("el-input", {
                      staticClass: "inline-block",
                      staticStyle: { width: "98%" },
                      attrs: { placeholder: "详细地址" },
                      model: {
                        value: allocForm.buyerRecvStreet,
                        callback: function($$v) {
                          _vm.$set(allocForm, "buyerRecvStreet", $$v)
                        },
                        expression: "allocForm.buyerRecvStreet"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left", width: "120px" } },
                  [
                    _c("el-input", {
                      staticClass: "inline-block",
                      staticStyle: { width: "95%" },
                      attrs: { placeholder: "联系人" },
                      model: {
                        value: allocForm.buyerRecvContractName,
                        callback: function($$v) {
                          _vm.$set(allocForm, "buyerRecvContractName", $$v)
                        },
                        expression: "allocForm.buyerRecvContractName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left", width: "120px" } },
                  [
                    _c("el-input", {
                      staticClass: "inline-block",
                      staticStyle: { width: "95%" },
                      attrs: { placeholder: "联系电话" },
                      model: {
                        value: allocForm.buyerRecvContactTel,
                        callback: function($$v) {
                          _vm.$set(allocForm, "buyerRecvContactTel", $$v)
                        },
                        expression: "allocForm.buyerRecvContactTel"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left", width: "150px" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "inline-block",
                      staticStyle: { width: "95%" },
                      attrs: {
                        type: "date",
                        placeholder: "选择日期",
                        "picker-options": _vm.pickerOptions0
                      },
                      model: {
                        value: allocForm.desireArriveDate,
                        callback: function($$v) {
                          _vm.$set(allocForm, "desireArriveDate", $$v)
                        },
                        expression: "allocForm.desireArriveDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left", width: "160px" } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.showShopAddrDlg(allocForm)
                          }
                        }
                      },
                      [_vm._v("选择地址")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.removeRetailerCom(allocForm.buyerShopId)
                          }
                        }
                      },
                      [_vm._v("移除")]
                    )
                  ]
                )
              ])
            : _vm._e()
        })
      ),
      _vm._v(" "),
      _vm.comnAllocForm.allocForms.length <= 0
        ? _c("tfoot", { staticClass: "foot" }, [_vm._m(2)])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c(
        "div",
        { staticClass: "title required", staticStyle: { width: "80px" } },
        [_vm._v("供应商")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: {
            "padding-left": "95px",
            width: "calc(100% - 95px - 20px)"
          }
        },
        [
          _c(
            "div",
            { staticClass: "pos-rel", staticStyle: { width: "313px" } },
            [
              _c("el-input", {
                staticClass: "width-2x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.comnAllocForm.sellerName,
                  callback: function($$v) {
                    _vm.$set(_vm.comnAllocForm, "sellerName", $$v)
                  },
                  expression: "comnAllocForm.sellerName"
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                on: { click: _vm.sellerSelect }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c(
        "div",
        { staticClass: "title required", staticStyle: { width: "80px" } },
        [_vm._v("税率(%)")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: {
            "padding-left": "95px",
            width: "calc(100% - 95px - 20px)"
          }
        },
        [
          _c(
            "div",
            { staticClass: "pos-rel", staticStyle: { width: "313px" } },
            [
              _c("el-input", {
                staticClass: "width-2x",
                on: {
                  change: function($event) {
                    _vm.taxRateChange(_vm.comnAllocForm.taxRate)
                  }
                },
                model: {
                  value: _vm.comnAllocForm.taxRate,
                  callback: function($$v) {
                    _vm.$set(_vm.comnAllocForm, "taxRate", $$v)
                  },
                  expression: "comnAllocForm.taxRate"
                }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small mb10",
            on: {
              click: function($event) {
                _vm.showSkuDlg()
              }
            }
          },
          [_vm._v("选择商品")]
        ),
        _vm._v(" "),
        _c(
          "el-form",
          { attrs: { model: _vm.comnAllocForm } },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.comnAllocForm.itemList,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: { align: "left", prop: "title", label: "名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "catName",
                    label: "分类",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "asmblAccFlag",
                    label: "组装件",
                    width: "130"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: scope.row.asmblAccFlag,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "asmblAccFlag", $$v)
                                },
                                expression: "scope.row.asmblAccFlag"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "price",
                    label: "含税价(元)",
                    width: "90"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { type: "text" },
                            on: {
                              change: function($event) {
                                _vm.changePrice(scope.row)
                              }
                            },
                            model: {
                              value: scope.row.price,
                              callback: function($$v) {
                                _vm.$set(scope.row, "price", $$v)
                              },
                              expression: "scope.row.price"
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "taxRate",
                    label: "税率(%)",
                    width: "90"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "ntxPrice",
                    label: "未税价(元)",
                    width: "90"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.ntxPrice != null
                            ? _c("span", [_vm._v(_vm._s(scope.row.ntxPrice))])
                            : _c("span", [_vm._v("0.00")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "right", label: "下单数量", width: "90" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: scope.row.quantity,
                              callback: function($$v) {
                                _vm.$set(scope.row, "quantity", $$v)
                              },
                              expression: "scope.row.quantity"
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "unit",
                    label: "单位",
                    width: "80"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "left", label: "说明" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: scope.row.desc,
                              callback: function($$v) {
                                _vm.$set(scope.row, "desc", $$v)
                              },
                              expression: "scope.row.desc"
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "left", label: "操作", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeGoods(_vm.allocFormItem.skuId)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("配货机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticStyle: { "text-align": "left", width: "300px" } }, [
          _vm._v("机构名称")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("地址信息")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("详细地址")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left", width: "120px" } }, [
          _vm._v("联系人")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left", width: "120px" } }, [
          _vm._v("联系电话")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left", width: "150px" } }, [
          _vm._v("要求到货日期")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left", width: "200px" } }, [
          _vm._v("操作")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticStyle: { "text-align": "center", "line-height": "40px" },
          attrs: { colspan: "7" }
        },
        [_c("span", { staticClass: "font-gray3" }, [_vm._v("暂无数据")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670a1cea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670a1cea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocFormTemplate.vue
// module id = 2968
// module chunks = 0